var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBinDangerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 88,
    viewBox: "0 0 90 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 5,
    width: 78,
    height: 78,
    rx: 39,
    fill: "#FFDCDC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.5823 54.2501C86.7088 62.0962 82.6918 69.2767 76.9736 75.0013C71.2553 80.7258 64.0575 84.7724 56.1725 86.6956C50.9586 87.9605 45.5619 88.3091 40.2269 87.7256C29.4852 86.478 19.55 81.4465 12.2249 73.5445C4.83159 65.6352 0.654578 55.2837 0.501851 44.4925C0.427983 36.4538 2.5658 28.5477 6.68468 21.6272C10.8036 14.7068 16.7471 9.03475 23.8739 5.22324C28.5989 2.73842 33.732 1.10971 39.0324 0.413454C44.3275 -0.294412 49.7057 -0.0921811 54.9317 1.01125C60.1777 2.11338 65.1749 4.16459 69.6735 7.06255C78.7961 12.9301 85.4426 21.9091 88.36 32.3071C88.5545 33.0428 88.7304 33.7602 88.9156 34.4591C89.0562 35.1458 89.1582 35.8397 89.2212 36.5376C89.2953 37.1997 89.3509 37.8434 89.4064 38.4504C89.4064 38.7447 89.4064 39.039 89.4712 39.3241C89.536 39.6092 89.4712 39.8851 89.4712 40.1518C89.3601 42.267 89.1101 43.6465 88.7582 43.8304C88.4063 44.0143 88.0174 43.0211 87.6748 41.283C87.5822 40.8415 87.4989 40.3633 87.4248 39.8391C87.3507 39.3149 87.1748 38.7723 87.0636 38.1837C86.9525 37.5951 86.8044 36.9698 86.684 36.3444C86.6192 36.0225 86.5729 35.6914 86.4895 35.3512L86.2117 34.3396C86.1006 33.8889 85.971 33.4199 85.8506 32.9509C83.2439 23.0607 77.1442 14.4307 68.6642 8.63518C64.4268 5.7227 59.6732 3.63208 54.6539 2.47347C49.618 1.31958 44.4135 1.07966 39.2917 1.76532C28.9416 3.12705 19.4786 8.28385 12.762 16.2223C9.42639 20.135 6.8262 24.6113 5.0855 29.4378C3.35299 34.259 2.49094 39.3461 2.53902 44.465C2.64903 54.8075 6.54251 64.7573 13.4935 72.4593C20.4563 80.2074 30.077 85.0996 40.4769 86.1806C45.6171 86.6615 50.8024 86.235 55.7928 84.9206C60.746 83.5935 65.4191 81.3944 69.5902 78.4279C78.012 72.4899 83.9437 63.6859 86.258 53.6891C86.6284 52.4384 86.7951 51.1968 87.0266 50.0657C87.1377 49.4955 87.2581 48.9529 87.3785 48.4378C87.4989 47.9228 87.5266 47.4447 87.6192 46.994C87.9155 45.2099 88.2674 44.0143 88.61 43.8856C88.9526 43.7568 89.2027 44.7224 89.3416 46.433C89.4948 48.7353 89.3233 51.0476 88.8323 53.3029L88.7767 53.542L88.5823 54.2501Z",
    fill: "#173962"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.834 37.4167H52.5007V54.1667C52.5007 55.2713 51.6052 56.1667 50.5007 56.1667H37.834C36.7294 56.1667 35.834 55.2713 35.834 54.1667V37.4167Z",
    stroke: "#FE5D7C",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.709 37.4167H55.6257",
    stroke: "#FE5D7C",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40 32.2083H48.3333",
    stroke: "#FE5D7C",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.043 41.5833L41.043 52",
    stroke: "#FE5D7C",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.293 41.5833L47.293 52",
    stroke: "#FE5D7C",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinDangerIcon);
export default __webpack_public_path__ + "static/media/BinDangerIcon.d4ef48afac5ac030e751179b574bee09.svg";
export { ForwardRef as ReactComponent };